export const notifications = {
  // Email subject lines
  subjects: {
    projectCreated: 'New project created: {{projectName}}',
    projectUpdated: 'Project updated: {{projectName}}',
    projectStatusChanged: 'Project status changed: {{projectName}}',
    projectAssigned: 'New project assigned: {{projectName}}',
    projectCompleted: 'Project completed: {{projectName}}',
    
    taskCreated: 'New task created: {{taskTitle}}',
    taskUpdated: 'Task updated: {{taskTitle}}',
    taskAssigned: 'New task assigned: {{taskTitle}}',
    taskStatusChanged: 'Task status changed: {{taskTitle}}',
    taskCompleted: 'Task completed: {{taskTitle}}',
    taskOverdue: 'Task overdue: {{taskTitle}}',
    taskDueSoon: 'Task due soon: {{taskTitle}}',
    
    customerCreated: 'New customer created: {{customerName}}',
    customerStatusChanged: 'Customer status changed: {{customerName}}',
    customerDataUpdated: 'Customer data updated: {{customerName}}',
    
    quotationCreated: 'New quotation created: {{quotationNumber}}',
    quotationStatusChanged: 'Quotation status changed: {{quotationNumber}}',
    
    dealCreated: 'New interaction recorded',
    dealStatusChanged: 'Interaction status changed',
    
    contractCreated: 'New contract created: {{contractName}}',
    contractStatusChanged: 'Contract status changed: {{contractName}}',
    
    organizationCreated: 'New organization created: {{organizationName}}',
    organizationUpdated: 'Organization data updated: {{organizationName}}',
    organizationDeleted: 'Organization deleted: {{organizationName}}',
    
    userAdded: 'Added to an organization',
    userRemoved: 'Removed from an organization',
    permissionsChanged: 'Your permissions have changed',
    
    welcomeToOrganization: 'Welcome to {{organizationName}}!',
    userInvitation: 'Invitation to {{organizationName}}',
    accountActivated: 'Account activated',
    roleChanged: 'Role changed'
  },

  // Email messages
  messages: {
    // Project notifications
    projectCreated: `
      <p>Dear {{userName}},</p>
      <p>A new project has been created in the system:</p>
      <h3>{{projectName}}</h3>
      <p><strong>Description:</strong> {{projectDescription}}</p>
      <p><strong>Start Date:</strong> {{startDate}}</p>
      <p><strong>End Date:</strong> {{endDate}}</p>
      <p><strong>Priority:</strong> {{priority}}</p>
      <p><strong>Created by:</strong> {{createdBy}}</p>
      <p>You can view project details in the system.</p>
    `,
    
    projectUpdated: `
      <p>Dear {{userName}},</p>
      <p>The following project has been updated:</p>
      <h3>{{projectName}}</h3>
      <p><strong>Changes:</strong></p>
      <ul>{{changes}}</ul>
      <p><strong>Updated by:</strong> {{updatedBy}}</p>
      <p>You can view project details in the system.</p>
    `,
    
    projectStatusChanged: `
      <p>Dear {{userName}},</p>
      <p>The status of the following project has changed:</p>
      <h3>{{projectName}}</h3>
      <p><strong>New Status:</strong> {{newStatus}}</p>
      <p><strong>Previous Status:</strong> {{oldStatus}}</p>
      <p><strong>Changed by:</strong> {{changedBy}}</p>
      <p>You can view project details in the system.</p>
    `,
    
    projectAssigned: `
      <p>Dear {{userName}},</p>
      <p>You have been assigned to the following project:</p>
      <h3>{{projectName}}</h3>
      <p><strong>Description:</strong> {{projectDescription}}</p>
      <p><strong>End Date:</strong> {{endDate}}</p>
      <p><strong>Priority:</strong> {{priority}}</p>
      <p><strong>Assigned by:</strong> {{assignedBy}}</p>
      <p>Please review the project details in the system.</p>
    `,
    
    projectCompleted: `
      <p>Dear {{userName}},</p>
      <p>The following project has been successfully completed:</p>
      <h3>{{projectName}}</h3>
      <p><strong>Completion Date:</strong> {{completionDate}}</p>
      <p><strong>Final Progress:</strong> {{finalProgress}}%</p>
      <p><strong>Completed by:</strong> {{completedBy}}</p>
      <p>Congratulations on successfully completing the project!</p>
    `,

    // Task notifications
    taskCreated: `
      <p>Dear {{userName}},</p>
      <p>A new task has been created{{#if projectName}} in the "{{projectName}}" project{{/if}}:</p>
      <h3>{{taskTitle}} ({{taskNumber}})</h3>
      <p><strong>Description:</strong> {{taskDescription}}</p>
      <p><strong>Priority:</strong> {{priority}}</p>
      <p><strong>Due Date:</strong> {{dueDate}}</p>
      <p><strong>Created by:</strong> {{createdBy}}</p>
      <p>You can view task details in the system.</p>
    `,
    
    taskUpdated: `
      <p>Dear {{userName}},</p>
      <p>The following task has been updated:</p>
      <h3>{{taskTitle}} ({{taskNumber}})</h3>
      <p><strong>Changes:</strong></p>
      <ul>{{changes}}</ul>
      <p><strong>Updated by:</strong> {{updatedBy}}</p>
      <p>You can view task details in the system.</p>
    `,
    
    taskAssigned: `
      <p>Dear {{userName}},</p>
      <p>You have been assigned to the following task:</p>
      <h3>{{taskTitle}} ({{taskNumber}})</h3>
      <p><strong>Description:</strong> {{taskDescription}}</p>
      <p><strong>Priority:</strong> {{priority}}</p>
      <p><strong>Due Date:</strong> {{dueDate}}</p>
      {{#if projectName}}<p><strong>Project:</strong> {{projectName}}</p>{{/if}}
      <p><strong>Assigned by:</strong> {{assignedBy}}</p>
      <p>Please review the task details in the system.</p>
    `,
    
    taskStatusChanged: `
      <p>Dear {{userName}},</p>
      <p>The status of the following task has changed:</p>
      <h3>{{taskTitle}} ({{taskNumber}})</h3>
      <p><strong>New Status:</strong> {{newStatus}}</p>
      <p><strong>Previous Status:</strong> {{oldStatus}}</p>
      <p><strong>Changed by:</strong> {{changedBy}}</p>
      <p>You can view task details in the system.</p>
    `,
    
    taskCompleted: `
      <p>Dear {{userName}},</p>
      <p>The following task has been successfully completed:</p>
      <h3>{{taskTitle}} ({{taskNumber}})</h3>
      <p><strong>Completion Date:</strong> {{completionDate}}</p>
      {{#if actualHours}}<p><strong>Time Spent:</strong> {{actualHours}} hours</p>{{/if}}
      <p><strong>Completed by:</strong> {{completedBy}}</p>
      <p>Congratulations on successfully completing the task!</p>
    `,
    
    taskOverdue: `
      <p>Dear {{userName}},</p>
      <p>⚠️ The following task is overdue:</p>
      <h3>{{taskTitle}} ({{taskNumber}})</h3>
      <p><strong>Due Date was:</strong> {{dueDate}}</p>
      <p><strong>Overdue by:</strong> {{daysOverdue}} days</p>
      <p><strong>Priority:</strong> {{priority}}</p>
      {{#if assignedTo}}<p><strong>Assigned to:</strong> {{assignedTo}}</p>{{/if}}
      <p>Please take action to complete the task as soon as possible.</p>
    `,
    
    taskDueSoon: `
      <p>Dear {{userName}},</p>
      <p>🕐 The following task is due soon:</p>
      <h3>{{taskTitle}} ({{taskNumber}})</h3>
      <p><strong>Due Date:</strong> {{dueDate}}</p>
      <p><strong>Due in:</strong> {{daysUntilDue}} days</p>
      <p><strong>Priority:</strong> {{priority}}</p>
      {{#if assignedTo}}<p><strong>Assigned to:</strong> {{assignedTo}}</p>{{/if}}
      <p>Please ensure the task is completed on time.</p>
    `,

    // User management notifications
    welcomeToOrganization: `
      <p>Dear {{userName}},</p>
      <p>Welcome to the <strong>{{organizationName}}</strong> YouCRM system!</p>
      <p><strong>Your Details:</strong></p>
      <ul>
        <li><strong>Name:</strong> {{userName}}</li>
        <li><strong>Email:</strong> {{userEmail}}</li>
        <li><strong>Role:</strong> {{userRole}}</li>
        <li><strong>Organization:</strong> {{organizationName}}</li>
      </ul>
      <p>You now have full access to the system according to your permission level.</p>
      <p>If you have any questions, please don't hesitate to contact us.</p>
    `,
    
    userInvitation: `
      <p>Dear {{userName}},</p>
      <p>You have been invited to the <strong>{{organizationName}}</strong> YouCRM system!</p>
      <p><strong>Invitation Details:</strong></p>
      <ul>
        <li><strong>Organization:</strong> {{organizationName}}</li>
        <li><strong>Role:</strong> {{userRole}}</li>
        <li><strong>Invited by:</strong> {{invitedBy}}</li>
      </ul>
      <p>To accept the invitation and activate your account, please log in to the system.</p>
    `,
    
    accountActivated: `
      <p>Dear {{userName}},</p>
      <p>Your account has been successfully activated in the <strong>{{organizationName}}</strong> YouCRM system.</p>
      <p>You now have full access to all system features that you are authorized to use.</p>
      <p>If you have any questions, please don't hesitate to contact us.</p>
    `,
    
    roleChanged: `
      <p>Dear {{userName}},</p>
      <p>Your permissions have been modified in the <strong>{{organizationName}}</strong> system.</p>
      <p><strong>Previous Role:</strong> {{oldRole}}</p>
      <p><strong>New Role:</strong> {{newRole}}</p>
      <p><strong>Changed by:</strong> {{changedBy}}</p>
      <p>The changes are effective immediately.</p>
    `
  },

  // Common email elements
  common: {
    greeting: 'Dear {{userName}},',
    signature: `
      <br>
      <p>Best regards,<br>
      <strong>{{organizationName}} Team</strong></p>
    `,
    footer: `
      <hr style="border: 1px solid #eee; margin: 20px 0;">
      <p style="color: #666; font-size: 14px;">
        This email was sent from the YouCRM system.<br>
        <strong>{{organizationName}}</strong><br>
        If you no longer wish to receive these notifications, please contact your system administrator.
      </p>
    `,
    viewInSystem: 'View in System',
    doNotReply: 'This is an automatically generated email. Please do not reply to this message.'
  },

  // Status and priority translations
  statuses: {
    // Project statuses
    planning: 'Planning',
    active: 'Active',
    completed: 'Completed',
    paused: 'Paused',
    cancelled: 'Cancelled',
    
    // Task statuses
    todo: 'To Do',
    in_progress: 'In Progress',
    pending: 'Pending',
    rejected: 'Rejected',
    inactive: 'Inactive',
    
    // Quotation statuses
    draft: 'Draft',
    sent: 'Sent',
    accepted: 'Accepted',
    expired: 'Expired',
    
    // Contract statuses
    valid: 'Valid'
  },
  
  // Field names for change tracking
  fields: {
    companyName: 'company name',
    name: 'name',
    email: 'email',
    phone: 'phone',
    address: 'address',
    taxNumber: 'tax number',
    notes: 'notes',
    status: 'status'
  },

  priorities: {
    low: 'Low',
    medium: 'Medium',
    high: 'High',
    urgent: 'Urgent'
  },

  roles: {
    super_admin: 'Super Administrator',
    admin: 'Administrator',
    user: 'User'
  },

  // UI translations for notification center
  title: 'Notifications',
  all: 'All',
  unread: 'Unread',
  markAllRead: 'Mark all as read',
  clearAll: 'Clear all',
  viewAll: 'View all',
  noNotifications: 'No notifications',
  noUnread: 'No unread notifications',
  confirmClearAll: 'Are you sure you want to clear all notifications?',
  settings: 'Notification settings',
  types: {
    task_assigned: 'Task assigned',
    task_completed: 'Task completed',
    task_overdue: 'Task overdue',
    project_update: 'Project update',
    deadline_reminder: 'Deadline reminder',
    system: 'System notification',
    mention: 'Mention'
  }
}; 